export default __webpack_public_path__ + "static/media/toggle.fde90018.svg";